import React, {FunctionComponent, useMemo} from "react";
import {tourService} from "../../../services/TourService";
import {TOUR_TABLE} from "../../../constants/Table";
import {tableUtils} from "../../../utils/tableUtils";
import Button from "../../atoms/Button";
import {ColorType} from "../../../types/bootstrap/BootstrapType";
import {useIntl} from "react-intl";
import PagedTable from "../table/PagedTable";
import FilterGroup from "../filters/FilterGroup";
import TextFilter from "../filters/TextFilter";
import {TourSearchObject} from "../../../interfaces/TourInterfaces";
import {activityService} from "../../../services/ActivityService";
import {customerService} from "../../../services/CustomerService";
import {WorkflowStatesEnum} from "../../../constants/workflow/WorkflowStates";
import AutocompleteFilterPageable from "../filters/AutocompleteFilterPageable";

interface TourListProps {
  className?: string,
  searchObject?: TourSearchObject;
  updateSearchField: (field: string, value: string | string[]) => void,
  onReset: () => void,
}

const TourList: FunctionComponent<TourListProps> = ({
  className = "",
  searchObject,
  updateSearchField,
  onReset
 }) => {
  const intl = useIntl()
  const columns = useMemo(() => tableUtils.getColumns(TOUR_TABLE(intl)), [intl])

  return (
    <>
      <FilterGroup className="gap-2">
        <TextFilter
          icon="Search"
          className="main-filter"
          value={searchObject?.tourName}
          onChange={(value) => updateSearchField("tourName", value)}
          title={intl.formatMessage({id: "tour_name_search"})}
          placeholder={intl.formatMessage({id: "tour_table_search_placeholder"})}
        />
        <AutocompleteFilterPageable
          id="customerId"
          title={intl.formatMessage({id: "customer_field"})}
          placeholder={intl.formatMessage({id: "customer_placeholder"})}
          onChange={(value) => updateSearchField("customerId", value)}
          value={searchObject?.customerId}
          fetchData={(page, filter) => customerService.getCustomersPage(page, {...filter, currentState: WorkflowStatesEnum.ACTIVE})}
          filterFieldName="fullName"
          filterFieldSearch="name"
        />
        <AutocompleteFilterPageable
          id="activityId"
          title={intl.formatMessage({id: "dropdown_header_activity"})}
          placeholder={intl.formatMessage({id: "activity_placeholder"})}
          onChange={(value) => updateSearchField("activityId", value)}
          value={searchObject?.activityId}
          fetchData={(page, filters) => activityService.getActivitiesPage(page, {...filters, status: WorkflowStatesEnum.ACTIVE})}
          filterFieldName="name"
        />
        <div>
          <Button onClick={onReset} color={ColorType.SECONDARY} >{intl.formatMessage({id: "header_menu_clear_search"})}</Button>
        </div>
      </FilterGroup>
      <PagedTable
        columns={columns}
        labelNoResult="tour_no_result"
        className={`${className} table`}
        fetchData={tourService.getToursPage}
        filters={searchObject}
        defaultSortBy={[{sortBy: "tourName"}]}
      />

    </>
  )
}

export default TourList
